class AllCollections {
	constructor() {
		this._init();
	}

	_init() {

		//Check if Collection menu is present
		var $class = this;
		var menu = $('#all-collections .content-menu');
		if(menu.length) {

			var menu_links = $('#all-collections .content-menu a');

			//Add scroll padding offset to page html

			$('html').css('scroll-padding-top', $class._getViewportOffset());

			console.log("offset: ", $class._getViewportOffset());

			$.fn.isInViewport = function() {

				var elementTop = $(this).offset().top;
				var elementBottom = elementTop + $(this).outerHeight();
				// Add offset from top
				var viewportTop = $class._getViewportOffset();

				var viewportBottom = viewportTop + $(window).height();

				return elementBottom > viewportTop && (elementTop - 90) < viewportTop;
			};

			// Adds event lister to each collection product section when in viewport
			$(window).on('resize scroll', function() {
				$('.grid.product-list').each(function() {
					var activeColor = $(this).attr('id');
					if ($(this).isInViewport()) {
						$('#all-collections .content-menu a[data-handle=' + $(this).attr('id') + ']').addClass('active');

					} else {
						$('#all-collections .content-menu a[data-handle=' + $(this).attr('id') + ']').removeClass('active');
					}
				});
			});
		}
	}

	_getViewportOffset() {

		let voffset = $(window).width() < 768 ? 30 : 0;

		return $(window).scrollTop() +
				$('#pageheader').outerHeight(true) +
				$('#all-collections .content-menu').outerHeight(true) - voffset;
	}
}

export default AllCollections


